import React, { ChangeEvent, FC, useEffect, useMemo, useState } from 'react';

import { Form, Select, Space } from 'antd';
import { CountryService } from '../../../services/CountryService';
import { TRANSLATION_CODES } from '../../constants';
import { splitPhoneNumber } from '../../utils';
import { useCompositorContext } from '../CompositorProvider';
import { JTextProps } from './../../models';
import { FormItem } from './../FormItem';
import './JPhone.scss';
import { JTextWithoutFormItem } from './JText';


export const JPhone: FC<JTextProps> = (props) => {
    const { translate } = useCompositorContext()
    const formInstance = Form.useFormInstance()
    const currentValue = Form.useWatch(props.fullname)

    const [number, setNumber] = useState<string>()
    const [prefix, setPrefix] = useState<string>()
    const [options, setOptions] = useState<JSX.Element[]>([])

    const prefixPlaceholder = useMemo(() => translate(TRANSLATION_CODES.PHONE_PREFIX_CODE), [])

    useEffect(() => {
        if (currentValue !== `${prefix} ${number}`) {
            const {
                number: currentNumber,
                prefix: currentPrefix
            } = splitPhoneNumber(currentValue)
            if (currentNumber && currentPrefix) {
                setPrefix(currentPrefix)
                setNumber(currentNumber)
            }
        }
    }, [currentValue])

    useEffect(() => {
        CountryService.getCountries().then(countries => {
            setOptions(countries?.map((country, i) => {
                const value = `+${country.phoneCode}`
                return (
                    <Select.Option key={i} value={value} label={`${country.name} ({value})`}>
                        {
                            country.flag && <div className='select-option-svg-icon' dangerouslySetInnerHTML={{ __html: country.flag }}></div>
                        }
                        <span className='select-option-label-name'>{country.name}</span>
                        <span className='select-option-label-value'> ({value})</span>
                    </Select.Option>
                )
            }))
        })
    }, [])

    useEffect(() => {
        if (typeof props.value === 'string') {
            const {
                prefix,
                number
            } = splitPhoneNumber(props.value)
            if (prefix) {
                setPrefix(prefix)
                setNumber(number)
            }
        }
    }, [props.value])

    useEffect(() => {
        if (prefix && number) {
            formInstance.setFieldValue(props.fullname, `${prefix} ${number}`)
        } else {
            formInstance.setFieldValue(props.fullname, '')
        }
    }, [number, prefix])

    const filterOption = (value: string, option?: JSX.Element) => {
        return !!(option?.props.label?.toLowerCase() ?? '').includes(value?.toLowerCase())
    }

    const onChangeCountryCode = (value: string) => {
        if (value.startsWith('+')) {
            setPrefix(value)
        }
    }

    const onChangePhoneNumber = (event: ChangeEvent<HTMLInputElement>) => {
        setNumber(event.target.value)
    }

    const onReset = () => {
        setNumber(undefined)
        setPrefix(undefined)
    }

    return (
        <FormItem fieldProps={props} onReset={onReset} >
            <Space.Compact>
                <Select
                    value={prefix}
                    showArrow
                    placeholder={prefixPlaceholder}
                    showSearch
                    onSelect={onChangeCountryCode}
                    filterOption={filterOption}
                >
                    {
                        options
                    }
                </Select>
                <JTextWithoutFormItem {...props} onChange={onChangePhoneNumber} value={number} />
            </Space.Compact>
        </FormItem>
    )
}

